import {useAppSelector} from '@/hooks';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import type {SubtitleObject} from '@PosterWhiteboard/items/transcript-item/subtitle/subtitle.types';

export const useGetCurrentSubtitleObject = (): SubtitleObject | undefined => {
  const currentPosterTime = useAppSelector((state) => {
    return state.posterEditor.currentTime;
  });

  const activeTranscriptItem = useGetSelectedTranscriptItem();

  if (!activeTranscriptItem) {
    return undefined;
  }

  return activeTranscriptItem.getSubtitleAtPosterTime(currentPosterTime)?.toObject();
};
